// Timeline

export const timelineData = [
    {
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/timeline/azerion.jpg",
        "company": "Azerion",
        "title": "DevOps Engineer Intern",
        "fromDate": "March 2021",
        "toDate": "September 2021",
    },
    {
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/timeline/Deloitte.png",
        "company": "Deloitte",
        "title": "Cloud Engineering",
        "fromDate": "July 2018",
        "toDate": "February 2020",
    },
    {
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/timeline/Deloitte.png",
        "company": "Deloitte",
        "title": "Business Solution Analyst Intern",
        "fromDate": "June 2017",
        "toDate": "August 2017",
    },
    {
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/companies/OmegaNotes.png",
        "company": "Omega Notes",
        "title": "Entrepreneurial Intern",
        "fromDate": "October 2016",
        "toDate": "May 2017",
    },
    {
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/timeline/Surge.png",
        "company": "Surge",
        "title": "Information Technology Intern",
        "fromDate": "May 2016",
        "toDate": "July 2016",
    },
]

export default timelineData